import React, { useEffect, useRef, useState } from 'react'
import { useLazyQuery, gql } from '@apollo/client'
import { useHistory } from 'react-router'
import styled from 'styled-components'
import { searchUsers } from '../../graphql-custom/queries'
import ProfPic from '../Rating/profpic'

const Wrapper = styled.div`
    position: relative;
    flex: 1;
    max-width: 280px;
    margin: 0 12px;

    input {
        width: 100%;
        background: rgba(255,255,255,0.12);
        border: 1px solid rgba(255,255,255,0.2);
        border-radius: 20px;
        padding: 4px 14px;
        color: #fff;
        font-size: 0.875rem;
        outline: none;
        transition: background 0.15s;

        &::placeholder { color: rgba(255,255,255,0.5); }
        &:focus {
            background: rgba(255,255,255,0.2);
            border-color: rgba(255,255,255,0.4);
        }
    }
`

const Dropdown = styled.div`
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.2);
    overflow: hidden;
    z-index: 1000;
`

const ResultRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    cursor: pointer;
    color: #222;
    font-size: 0.9rem;

    &:hover { background: #f5f5f5; }
`

const EmptyRow = styled.div`
    padding: 10px 14px;
    color: #888;
    font-size: 0.875rem;
`

export default function UserSearch() {
    const [query, setQuery] = useState('')
    const [open, setOpen] = useState(false)
    const containerRef = useRef(null)
    const history = useHistory()

    const [runSearch, { data, loading }] = useLazyQuery(gql(searchUsers))
    const results = data?.searchUsers || []

    useEffect(() => {
        if (!query.trim()) { setOpen(false); return }
        const timer = setTimeout(() => {
            runSearch({ variables: { query: query.trim() } })
            setOpen(true)
        }, 300)
        return () => clearTimeout(timer)
    }, [query, runSearch])

    useEffect(() => {
        const handler = e => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setOpen(false)
            }
        }
        document.addEventListener('mousedown', handler)
        return () => document.removeEventListener('mousedown', handler)
    }, [])

    const handleSelect = username => {
        history.push(`/users/${username}`)
        setQuery('')
        setOpen(false)
    }

    return (
        <Wrapper ref={containerRef}>
            <input
                value={query}
                onChange={e => setQuery(e.target.value)}
                placeholder="Search users..."
            />
            {open && (
                <Dropdown>
                    {loading && <EmptyRow>Searching...</EmptyRow>}
                    {!loading && results.length === 0 && <EmptyRow>No users found</EmptyRow>}
                    {results.map(r => (
                        <ResultRow key={r.username} onClick={() => handleSelect(r.username)}>
                            <ProfPic username={r.username} height='32px' width='32px'/>
                            {r.username}
                        </ResultRow>
                    ))}
                </Dropdown>
            )}
        </Wrapper>
    )
}
